// Funcion para comprobar si el NIF es correcto haciendo una petición a la Lambda
import axiosApi from '../axios/axios-api';

export default async function checkGovernmentIdentfier(
  token,
  identifier,
  identifier_type = 'NIP'
) {
  const url = `checkIdentifier?identifier=${identifier}&identifier_type=${identifier_type}`;

  if (process.env.REACT_APP_URL_API) {
    try {
      const response = await axiosApi.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        },
      });
      return {
        code: response?.data?.code ?? 500,
        message: response?.data?.message ?? '',
        data: response?.data?.data ?? null,
      };
    } catch (error) {
      let data = {
        code: 500,
        message: 'Error en la petición',
        data: 'Error en la petición',
      };
      return data;
    }
  }
}
